import "./Headerpage.css";
import { Link, Navigate, useLocation, useNavigate } from "react-router-dom";
import React, { useContext, useState } from "react";
import logo from "../../../img/AIASA.png";
import WhiteLogo from "../../../img/WhiteLogo.png";
import RedLogo from "../../../img/Redlogo.png";
import { UserContext } from "../../../context/UserDetails";
import Subnav from "./Subnav";
import FB from "../../../img/socialicons/facebook.png";
import INS from "../../../img/socialicons/insta.png";
import WHATS from "../../../img/socialicons/whastapp.png";
import TWITT from "../../../img/socialicons/twitter.svg";
import LINKD from "../../../img/socialicons/linkedin.png";
import YOUTUBE from "../../../img/socialicons/youtube.png";
import TELEGRAM from "../../../img/socialicons/telegram.png";
import { useEffect } from "react";
import { AxiosInstance } from "../../../axios";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import CartIcon from "./CartIcon";
import WishlistIcon from "./WishlistIcon";
import { clearBookFilters } from "../../../redux/purchaseBookFilterSlice";
import { useDispatch } from "react-redux";
// import NotificationIcon from "./NotificationIcon";
import { employeeRoutes } from "../../../AppConfig";

function HeaderHome() {
  const menuList = JSON.parse(sessionStorage.getItem("menu_list")) || [];
  const location = useLocation();
  const [dropdownClicked, setDropdownClicked] = useState(false);
  const { user, logout } = useContext(UserContext);
  // logout function call
  const Logout = () => {
    logout();
  };
  const handleLogo = () => {
    navigate("/");
  };
  const [isOpen, setIsOpen] = useState(false);
  const [isOpens, setIsOpens] = useState(false);
  const [sideOpen, setSideOpen] = useState(false);
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
  };
  const dispatch = useDispatch();

  const handleNav = (navItem, type) => {
    dispatch(clearBookFilters());
    navigate(`${navItem}`);
    // if (type === 0) {
    sessionStorage.setItem("stateRefreshs", true);
    localStorage.setItem("stateRefreshs", true);
    // }
    // if (type === 1) {
    sessionStorage.setItem("stateRefreshs_test", true);
    localStorage.setItem("stateRefreshs_test", true);
    // }
    // if (type === 3) {
    sessionStorage.setItem("stateRefreshs_spl", true);
    localStorage.setItem("stateRefreshs_spl", true);
    // }
    // if (type === 4) {
    sessionStorage.setItem("stateRefreshs_model", true);
    localStorage.setItem("stateRefreshs_model", true);
    // }
    // if (type === 5) {
    sessionStorage.setItem("stateRefreshs_mock", true);
    localStorage.setItem("stateRefreshs_mock", true);
    // }
    // if (type === 2) {
    sessionStorage.setItem("stateRefreshs_coun", true);
    localStorage.setItem("stateRefreshs_coun", true);
    // }
  };

  const ToggleOpen = (item) => {
    dispatch(clearBookFilters());
    navigate(item);
    setSideOpen(!sideOpen);
    const modal_close = document.querySelector("#MobileMenuClose");
    if (modal_close) {
      modal_close.click();
    }
    sessionStorage.setItem("stateRefreshs", true);
    localStorage.setItem("stateRefreshs", true);
    sessionStorage.setItem("stateRefreshs_test", true);
    localStorage.setItem("stateRefreshs_test", true);
    sessionStorage.setItem("stateRefreshs_spl", true);
    localStorage.setItem("stateRefreshs_spl", true);
    sessionStorage.setItem("stateRefreshs_model", true);
    localStorage.setItem("stateRefreshs_model", true);
    sessionStorage.setItem("stateRefreshs_mock", true);
    localStorage.setItem("stateRefreshs_mock", true);
    sessionStorage.setItem("stateRefreshs_coun", true);
    localStorage.setItem("stateRefreshs_coun", true);
  };
  const toggleDropdowns = () => {
    setIsOpens(!isOpens);
  };
  // Gallery Access
  const hasGalleryAccess = user?.menu_list?.some((id) => id >= 49 && id <= 61);
  // get user id
  const userJSON = sessionStorage.getItem("userDetails");
  let userid = null;
  let role_id = null;
  let user_type = null;
  let staff_status = null;
  let menuData = null;
  if (userJSON) {
    const user = JSON.parse(userJSON);
    if (user && user.user_id) {
      userid = user?.user_id;
      role_id = user.role_id;
      user_type = user?.user_type;
      menuData = user.menu_list;
      staff_status = user.staff_status;
    }
  } else {
    console.log("User Id cannot available in session storage");
  }
  const [notifyList, setNotifyList] = useState();
  // const [menuList, setMenuList] = useState(menuData);
  const [tPer, setTPer] = useState([]);

  const navigate = useNavigate();
  const [cartList, setCartList] = useState();

  useEffect(() => {
    if (userid !== null) {
      const fetchCategories = async () => {
        try {
          const response = await AxiosInstance.post("api/book/cart/list", {
            user_id: userid,
          });
          // const response = await AxiosInstance.post("api/book/cart/list", { user_id: "973e0ad2a0b226d2a1dec9a065faaa2e" });

          if (response.data.status) {
            setCartList(response.data.data);
          }
        } catch (error) {
          console.error("Error fetching categories:", error);
        }
      };
      fetchCategories();
    }
  }, []);

  const [wishlist, setwishList] = useState();

  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const data = {
          search: "",
          category_id: "",
          group_course_id: "",
          subject_id: "",
          medium: "",
          is_set: "",
          view_all_book: 0,
          user_id: userid,
          // user_id:"ef31d049c96a7e5ae176cd3c34cbecac",
          book_id: "",
        };
        const response = await AxiosInstance.post(
          "api/book/view_all_books",
          data
        );
        // const response = await AxiosInstance.post("api/book/cart/list", { user_id: "973e0ad2a0b226d2a1dec9a065faaa2e" });
        if (response.data.status) {
          setwishList(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);
  // get batch for user
  useEffect(() => {
    if (userid) {
      AxiosInstance.post("api/batch/list/byUser", {
        user_id: userid,
      })
        .then((res) => {
          if (res.data.status === true) {
            let df = res.data.data;

            setTPer(df);
          }
        })
        .catch((error) => {
          return error;
        });
    }
  }, []);
  // test performance menu click

  const handleTeamClick = (batch_id) => {
    navigate(`/TestPerformance/${batch_id}`);
    const modal_close = document.querySelector("#MobileMenuClose");
    if (modal_close) {
      modal_close.click();
    }
  };
  const handleWishlist = () => {
    navigate(`/Wishlist`);
  };
  const handleCartlist = () => {
    navigate(`/AddToCart`);
  };
  // view schedule menu click

  const handleSchedule = (batch_id, batch_type) => {
    navigate(`/TestViewSchedule/${batch_id}/${batch_type}`);
    const modal_close = document.querySelector("#MobileMenuClose");
    if (modal_close) {
      modal_close.click();
    }
  };

  const handleSocialIcons = (nam) => {
    if (nam === "Fac") {
      window.open(
        "https://www.facebook.com/annatnpsccenter?mibextid=ZbWKwL",
        "_blank"
      );
    } else if (nam === "You") {
      window.open("https://www.youtube.com/@ANNAIASACADEMY-KPM", "_blank");
    } else if (nam === "Tel") {
      window.open("https://t.me/annaiasacademy", "_blank");
    } else if (nam === "Ins") {
      window.open(
        "https://www.instagram.com/anna_ias_academy?igsh=MjNmc2M1ajYzaWhl&utm_source=qr",
        "_blank"
      );
    } else if (nam === "Wha") {
      window.open(
        "https://whatsapp.com/channel/0029VaBYURMIXnlmlHyKao1o",
        "_blank"
      );
    } else if (nam === "Lin") {
      window.open(
        "https://www.linkedin.com/in/anna-ias-academy-6880093a4",
        "_blank"
      );
    } else if (nam === "Twitt") {
      window.open("https://x.com/aiakpm1?s=21", "_blank");
    }
  };
  const [categories, setCategories] = useState([]);
  // New of Course content
  // Fetch categories from the API
  useEffect(() => {
    const fetchCategorie_list = async () => {
      try {
        const response = await AxiosInstance.get("api/course/category_list");
        if (response.data.status) {
          setCategories(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };

    fetchCategorie_list();
  }, []);
  const AdminMenu = [
    {
      lable: "Admission List",
      value: "Admission List",
      path: "ListViewStudentConfirm",
    },
    {
      lable: "Batch",
      value: "Batch",
      path: "ViewCourseBatch",
    },
    {
      lable: "Faculty",
      value: "Faculty",
      path: "Faculties",
    },
    {
      lable: "Test List",
      value: "Test List",
      path: "/TestList",
    },
    {
      lable: "Class List",
      value: "Class List",
      path: "/ClassList",
    },
    // {
    //   lable: "Panel List",
    //   value: "Panel List",
    //   path: "/Panellist",
    // },
    {
      lable: "Interview List",
      value: "Interview List",
      path: "/Interviewlist",
    },
    {
      lable: "Registered User",
      value: "Registered User",
      path: "RegisteredUser",
    },
    {
      lable: "Course Management",
      value: "Course Management",
      path: "/CourseManagement",
    },
    {
      lable: "Announcements",
      value: "Announcements",
      path: "/Announcement",
    },
    {
      lable: "Coupon Code",
      value: "Coupon Code",
      path: "/ListCouponCode",
    },
    {
      lable: "Books",
      value: "Books",
      path: "/studyMaterials/Books/list",
    },
    {
      lable: "Sales",
      value: "Sales",
      path: "/ListPurchase",
    },
    {
      lable: "Courier Charges",
      value: "Courier Charges",
      path: "/CourierCharges",
    },
    {
      lable: "Reviews",
      value: "Reviews",
      path: "/studyMaterials/Books/Reviews",
    },
    {
      lable: "Reward Points",
      value: "Reward Points",
      path: "/RewardPoints",
    },
    {
      lable: "RBAC",
      value: "RBAC",
      path: "/roleList",
    },
  ];
  const StudentMenu = [
    {
      lable: "Transaction History",
      value: "Transaction History",
      path: "/TransactionHistory",
    },
    {
      lable: "Interview Performance",
      value: "Interview Performance",
      path: "StudentFeedBackList",
    },
    {
      lable: "Test Performance",
      value: "Test Performance",
      path: "TestPerformanceListView",
    },
    {
      lable: "View Schedule",
      value: "View Schedule",
      path: "",
    },
    {
      lable: "Class Performance",
      value: "Class Performance",
      path: "ClassPerformanceListView",
    },
    {
      lable: "Download Hallticket",
      value: "Download Hallticket",
      path: "/DownloadHallTicket",
    },
    {
      lable: "Profile",
      value: "Profile",
      path: "/StudentProfile",
    },
    {
      lable: "Coupon Code",
      value: "Coupon Code",
      path: "/StudentCouponCode",
    },
    {
      lable: "Reward Points",
      value: "Reward Points",
      path: "/StudentRewardPoints",
    },
  ];

  return (
    <>
      {/* desktop  navabr   */}
      <div className="HeaderPage MobileRespo ">
        <div className="row ">
          <div className=" head ">
            <div className="row">
              <div className="col-md-4 col-lg-6 ">
                <img
                  src={FB}
                  alt="facebook"
                  id="socialIcons"
                  onClick={() => handleSocialIcons("Fac")}
                />
                <span className="border" id="border"></span>
                <img
                  src={INS}
                  alt="insta"
                  id="socialIcons"
                  onClick={() => handleSocialIcons("Ins")}
                />
                <span className="border" id="border"></span>
                <img
                  src={WHATS}
                  alt="whastapp"
                  id="socialIcons"
                  onClick={() => handleSocialIcons("Wha")}
                />
                <span className="border" id="border"></span>
                <img
                  src={TWITT}
                  alt="twitter"
                  id="socialIcons"
                  onClick={() => handleSocialIcons("Twitt")}
                />
                <span className="border" id="border"></span>
                <img
                  src={LINKD}
                  alt="Linkedin"
                  id="socialIcons"
                  onClick={() => handleSocialIcons("Lin")}
                />
                <span className="border" id="border"></span>
                <img
                  src={YOUTUBE}
                  alt="youtube"
                  id="socialIcons"
                  onClick={() => handleSocialIcons("You")}
                />
                <span className="border" id="border"></span>
                <img
                  src={TELEGRAM}
                  alt="telegram"
                  id="socialIcons"
                  onClick={() => handleSocialIcons("Tel")}
                />
                <span className="border" id="border"></span>
              </div>
              <div className="col-md-2 col-lg-2"></div>
              <div className="col-md-4 col-lg-4 d-flex justify-content-end px-4 gap-3">
                <div className="d-flex align-items-center">
                  <WishlistIcon
                    wishlist={wishlist}
                    handleWishlist={user_type === 2 ? handleWishlist : () => {}}
                  />
                  <span className="ms-1">Wishlist</span>
                </div>

                <div className="d-flex align-items-center">
                  <CartIcon
                    cartList={cartList}
                    handleCartlist={user_type === 2 ? handleCartlist : () => {}}
                  />
                  <span className="ms-1">Cart</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="row ">
          <div className="col-md-12  d-flex p-0">
            <div className="col-md-2 col-xl-2 col-sm-6" id="brand">
              <div className="brand ">
                <img src={WhiteLogo} alt="LogoImage" onClick={handleLogo} />
              </div>
            </div>
            <div className="col-md-10 col-xl-10 col-sm-6">
              <div className="content ">
                <div className="firstHeader">
                  <ul>
                    <li
                      className="dropdown-toggle"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Gallery
                      <ul className="dropdown-menu">
                        {/* === Images === */}
                        <li>
                          <Link
                            onClick={() =>
                              handleNav(
                                user_type !== 2
                                  ? "/GalleryImages"
                                  : "/GalleryImages",
                                0
                              )
                            }
                            to="javascript:void(0)"
                          >
                            Images
                          </Link>
                        </li>

                        {/* === Videos === */}
                        <li>
                          <Link
                            onClick={() =>
                              handleNav(
                                user_type !== 2
                                  ? "/GalleryVideos"
                                  : "/GalleryVideos",
                                1
                              )
                            }
                            to="javascript:void(0)"
                          >
                            Videos
                          </Link>
                        </li>

                        {/* === Slides (only for admin or users with gallery access) === */}
                        <li>
                          {user &&
                            (user_type === 1 ||
                              user?.menu_list?.some(
                                (id) => id >= 49 && id <= 61
                              )) && (
                              <Link
                                onClick={() => handleNav("/ViewBannerAdmin")}
                                to="javascript:void(0)"
                              >
                                Slides
                              </Link>
                            )}
                        </li>
                      </ul>
                    </li>
                    <span className="border"></span>

                    <li className="firstheader-contact">
                      <Link
                        onClick={() => handleNav("ContactUs")}
                        to="javascript:void(0)"
                        className="nav-link active"
                      >
                        Contact us
                      </Link>
                    </li>
                  </ul>
                </div>
                <div className="secondHeader ">
                  <ul>
                    <li onClick={() => ToggleOpen(`/`)}>Home</li>
                    <span className="border"></span>
                    <li
                      className="dropdown-toggle"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      About Us
                      <ul className="dropdown-menu">
                        {/* === Images === */}
                        <li>
                          <Link
                            onClick={() => handleNav("/WhoWeAre")}
                            to="javascript:void(0)"
                          >
                            Who We Are
                          </Link>
                        </li>

                        {/* === Videos === */}
                        <li>
                          <Link
                            onClick={() => handleNav("/WhyChooseUs")}
                            to="javascript:void(0)"
                          >
                            Why Choose Us
                          </Link>
                        </li>
                      </ul>
                    </li>
                    <span className="border"></span>
                    <li
                      className={`nav-link dropdown-toggle ${
                        isOpen ? "open" : ""
                      }`}
                      onClick={toggleDropdowns}
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      About Courses
                      <ul className={`dropdown-menu ${isOpen ? "open" : ""}`}>
                        {categories.map((category) => (
                          <li key={category.id}>
                            <Link
                              onClick={() =>
                                ToggleOpen(
                                  `/CourseContent/${category.name}/${category.id}`
                                )
                              }
                              to="javascript:void(0)"
                            >
                              {category.name}
                            </Link>
                          </li>
                        ))}
                      </ul>
                    </li>

                    <span className="border"></span>
                    <li
                      className="dropdown-toggle"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      Admission
                      <ul className="dropdown-menu">
                        <li>
                          <Link
                            onClick={() =>
                              handleNav(
                                user_type === 2
                                  ? "/Admission/Course"
                                  : user_type && user_type !== 2
                                  ? "/ListViewStudentConfirm/0"
                                  : "/login",
                                0
                              )
                            }
                            to="javascript:void(0)"
                          >
                            Courses
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={() =>
                              handleNav(
                                user_type === 2
                                  ? "/Admission/TestBatch"
                                  : user_type && user_type !== 2
                                  ? "/ListViewStudentConfirm/1"
                                  : "/login",
                                1
                              )
                            }
                            to="javascript:void(0)"
                          >
                            Test Batches
                          </Link>
                        </li>
                        <li>
                          <Link
                            onClick={() =>
                              handleNav(
                                user_type === 2
                                  ? "/Admission/SpecialClasses"
                                  : user_type && user_type !== 2
                                  ? "/ListViewStudentConfirm/3"
                                  : "/login",
                                3
                              )
                            }
                            to="javascript:void(0)"
                          >
                            Special Classes
                          </Link>
                        </li>
                        <>
                          <li>
                            <Link
                              onClick={() =>
                                handleNav(
                                  user_type === 2
                                    ? "/Admission/Modelexam"
                                    : user_type && user_type !== 2
                                    ? "/ListViewStudentConfirm/4"
                                    : "/login",
                                  4
                                )
                              }
                              to="javascript:void(0)"
                              // to={
                              //   user_type !== 2 ? "/ListViewStudentConfirm/4" : "/Admission/Modelexam"}
                            >
                              Model Exams
                            </Link>
                          </li>
                          <li>
                            <Link
                              onClick={() =>
                                handleNav(
                                  user_type !== 2
                                    ? "/ListViewStudentConfirm/5"
                                    : "/Admission/Mockinterview",
                                  5
                                )
                              }
                              to="javascript:void(0)"
                              // to={
                              //   user_type !== 2 ? "/ListViewStudentConfirm/5" : "/Admission/Mockinterview"}
                            >
                              Mock Interviews
                            </Link>
                          </li>
                          {/*  <li>
                              <Link
                                onClick={() =>
                                  handleNav(
                                    user_type !== 2
                                      ? "/ListViewStudentConfirm/2"
                                      : "/Admission/Counselling",
                                    2
                                  )
                                }
                                to="javascript:void(0)"
                                // to={
                                //   user_type !== 2 ? "/ListViewStudentConfirm/2" : "/Admission/Counselling"}
                              >
                                Counsellings
                              </Link>
                            </li> */}
                        </>
                        {/* )} */}
                      </ul>
                    </li>

                    <span className="border"></span>
                    <li
                      className=""
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <Link
                        onClick={() => {
                          const studyMaterialIds = [
                            3, 4, 5, 6, 13, 14, 15, 16, 17, 18, 19, 20, 22, 23,
                            24, 25, 26, 27, 28, 29,
                          ];

                          const hasStudyAccess =
                            Array.isArray(user?.menu_list) &&
                            user.menu_list.some((id) =>
                              studyMaterialIds.includes(id)
                            );

                          let targetPath = "/StudyMaterial/Books"; // guest route

                          if (
                            user_type === 1 ||
                            user_type === 3 ||
                            user_type === 4 ||
                            user_type === 5 ||
                            hasStudyAccess
                          ) {
                            targetPath = "/studyMaterials/Books/list"; // internal route
                          }

                          handleNav(targetPath, 0);
                        }}
                        to="javascript:void(0)"
                        className="nav-link active"
                      >
                        Study Materials
                      </Link>
                    </li>

                    {/* <span className="border"></span>
                 
                    <span className="border"></span> */}

                    {/* <span className="border"></span> */}

                    {/* <span className="border"></span> */}

                    {/* <span className="border"></span> */}
                    {user?.user_id ? (
                      <OverlayTrigger
                        placement="top"
                        overlay={
                          <Tooltip id="tooltip" className="tool_eve">
                            {user?.full_name}
                            <br />
                            {user?.Email}
                          </Tooltip>
                        }
                      >
                        <li className="buttonStyle dropdown">
                          <div className="dropdown-menu" id="menulist">
                            {menuList && (
                              <>
                                {/* === STUDENT MENU === */}
                                {user_type === 2 &&
                                  StudentMenu.map((item, i) => {
                                    if (item.value === "View Schedule") {
                                      return (
                                        <div
                                          className="dropdowns mt-3 mb-3"
                                          key={i}
                                        >
                                          <a
                                            className="dropdown-toggle"
                                            data-bs-toggle="dropdown"
                                            aria-expanded="false"
                                          >
                                            {item.lable}
                                          </a>

                                          {tPer && tPer.length > 0 ? (
                                            <ul id="SideLists">
                                              {tPer.map((batch) => (
                                                <li key={batch.batch_id}>
                                                  <Link
                                                    className="nav-link"
                                                    to="javascript:void(0)"
                                                    onClick={() =>
                                                      handleSchedule(
                                                        batch.batch_id,
                                                        batch.batch_type
                                                      )
                                                    }
                                                  >
                                                    {batch.batch_name}
                                                  </Link>
                                                </li>
                                              ))}
                                            </ul>
                                          ) : (
                                            <ul id="SideLists">
                                              <li>
                                                <Link
                                                  className="nav-link"
                                                  to="javascript:void(0)"
                                                >
                                                  No Batch found
                                                </Link>
                                              </li>
                                            </ul>
                                          )}
                                        </div>
                                      );
                                    }

                                    // Default case for other student menu items
                                    return (
                                      <p key={i}>
                                        <Link
                                          to="javascript:void(0)"
                                          onClick={() => ToggleOpen(item.path)}
                                        >
                                          {item.lable}
                                        </Link>
                                      </p>
                                    );
                                  })}

                                {/* === ADMIN MENU === */}
                                {user_type === 1 &&
                                  AdminMenu.map((item, i) => (
                                    <p key={i}>
                                      <Link
                                        to="javascript:void(0)"
                                        onClick={() => ToggleOpen(item.path)}
                                      >
                                        {item.lable}
                                      </Link>
                                    </p>
                                  ))}

                                {/* === STAFF MENU === */}
                                {user_type !== 1 &&
                                  user_type !== 2 &&
                                  Array.isArray(menuList) &&
                                  (() => {
                                    const accessibleRoutes = employeeRoutes
                                      .filter(
                                        (r, i, self) =>
                                          i ===
                                          self.findIndex((x) => x.id === r.id)
                                      )
                                      .filter((route) =>
                                        menuList.some(
                                          (menuId) =>
                                            Number(menuId) === Number(route.id)
                                        )
                                      );

                                    const groupedRoutes =
                                      accessibleRoutes.reduce((acc, route) => {
                                        if (!acc[route.module])
                                          acc[route.module] = [];
                                        acc[route.module].push(route);
                                        return acc;
                                      }, {});

                                    return (
                                      <>
                                        {/* Always show My Profile */}
                                        <p>
                                          <Link
                                            to="javascript:void(0)"
                                            onClick={() =>
                                              ToggleOpen("/facultyProfile")
                                            }
                                          >
                                            My Profile
                                          </Link>
                                        </p>

                                        {/* Dynamic menus */}
                                        {Object.entries(groupedRoutes)?.map(
                                          ([moduleName, routes]) => {
                                            const filteredRoute =
                                              routes?.filter(
                                                (route) => route?.order === "1"
                                              );
                                            const firstRoute =
                                              filteredRoute?.[0];

                                            if (
                                              moduleName === "Study Materials"
                                            ) {
                                              const uniqueSubpages =
                                                Object.values(
                                                  routes
                                                    .filter(
                                                      (route) =>
                                                        route?.order === "1"
                                                    )
                                                    .reduce((acc, route) => {
                                                      const key = `${route.module}-${route.subpage}`;
                                                      if (!acc[key])
                                                        acc[key] = route;
                                                      return acc;
                                                    }, {})
                                                );

                                              return (
                                                <div
                                                  key={moduleName}
                                                  className="module-block"
                                                >
                                                  <div className="subpage-container">
                                                    {uniqueSubpages && (
                                                      <div className="subpage-block">
                                                        {uniqueSubpages.map(
                                                          (route) => (
                                                            <p key={route.id}>
                                                              <Link
                                                                to="javascript:void(0)"
                                                                onClick={() =>
                                                                  ToggleOpen(
                                                                    route.path.startsWith(
                                                                      "/"
                                                                    )
                                                                      ? route.path
                                                                      : `/${route.path}`
                                                                  )
                                                                }
                                                              >
                                                                {route.subpage}
                                                              </Link>
                                                            </p>
                                                          )
                                                        )}
                                                      </div>
                                                    )}
                                                  </div>
                                                </div>
                                              );
                                            }

                                            if (
                                              moduleName === "Faculty Profile"
                                            ) {
                                              return (
                                                <div key={moduleName}>
                                                  <div>
                                                    {routes.map((route) => (
                                                      <p key={route.id}>
                                                        <Link
                                                          to="javascript:void(0)"
                                                          onClick={() =>
                                                            ToggleOpen(
                                                              route.path.startsWith(
                                                                "/"
                                                              )
                                                                ? route.path
                                                                : `/${route.path}`
                                                            )
                                                          }
                                                        >
                                                          {route.page}
                                                        </Link>
                                                      </p>
                                                    ))}
                                                  </div>
                                                </div>
                                              );
                                            }

                                            if (!firstRoute) return null;
                                            return (
                                              <p key={firstRoute.id}>
                                                <Link
                                                  to="javascript:void(0)"
                                                  onClick={() =>
                                                    ToggleOpen(
                                                      firstRoute.path.startsWith(
                                                        "/"
                                                      )
                                                        ? firstRoute.path
                                                        : `/${firstRoute.path}`
                                                    )
                                                  }
                                                >
                                                  {firstRoute.module}
                                                </Link>
                                              </p>
                                            );
                                          }
                                        )}
                                      </>
                                    );
                                  })()}

                                {/*  Always show Logout for all logged-in users */}
                                <p>
                                  <Link onClick={Logout}>Logout</Link>
                                </p>
                              </>
                            )}
                          </div>
                        </li>
                      </OverlayTrigger>
                    ) : (
                      <li className="buttonStyles">
                        <Link className="nav-link" to="/login">
                          Login
                        </Link>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* mobile navabr /tablet  */}
      <nav className="navbar shadow mobile_nav d-lg-none d-xl-none">
        <div className="mobile_svv head">
          {/* === LOGO === */}
          <a className="navbar-brand" href="#">
            <img
              src={RedLogo}
              onClick={handleLogo}
              alt="mobile_logo"
              className="mobile_logo"
            />
          </a>

          {/* === TOGGLER === */}
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#sidebarNav"
            aria-controls="sidebarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="material-icons navbarIcon">menu</span>
          </button>

          {/* === SIDEBAR / OFFCANVAS MENU === */}
          <div
            className={`offcanvas offcanvas-start ${sideOpen ? "hiding" : ""}`}
            tabIndex="-1"
            id="sidebarNav"
            aria-labelledby="sidebarNavLabel"
          >
            <div className="offcanvas-header">
              <div className="sidebar_logo">
                <img
                  src={WhiteLogo}
                  alt="sidebar_logo"
                  onClick={handleLogo}
                  className="sidebar_logo"
                />
              </div>
              <button
                type="button"
                id="MobileMenuClose"
                className="btn-close text-white"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>

            <div className="offcanvas-body">
              <ul className="navbar-nav">
                {/* === HOME === */}
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="javascript:void(0)"
                    onClick={() => ToggleOpen("/")}
                  >
                    Home
                  </Link>
                </li>

                {/* === ABOUT COURSES === */}
                <li
                  className={`nav-link dropdown-toggle ${isOpen ? "open" : ""}`}
                  onClick={toggleDropdowns}
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  About Courses
                  <span
                    class="material-icons dropdown_span"
                    onClick={toggleDropdown}
                  >
                    expand_more
                  </span>
                  <ul className={`dropdown-menu ${isOpen ? "open" : ""}`}>
                    {categories.map((category) => (
                      <li key={category.id}>
                        <Link
                          onClick={() =>
                            ToggleOpen(
                              `/CourseContent/${category.name}/${category.id}`
                            )
                          }
                          to="javascript:void(0)"
                        >
                          {category.name}
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
                {/* === ADMISSION === */}
                <li
                  className={`nav-item dropdown-toggle ${isOpen ? "open" : ""}`}
                  onClick={toggleDropdown}
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Admission
                  <span
                    class="material-icons dropdown_span"
                    onClick={toggleDropdown}
                  >
                    expand_more
                  </span>
                  <ul className={`dropdown-menu ${isOpen ? "open" : ""}`}>
                    <li>
                      <Link
                        onClick={() =>
                          ToggleOpen(
                            `${
                              user_type !== 2
                                ? "/ListViewStudentConfirm/0"
                                : "/Admission/Course"
                            }`
                          )
                        }
                        to="javascript:void(0)"
                      >
                        Courses
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() =>
                          ToggleOpen(
                            `${
                              user_type !== 2
                                ? "/ListViewStudentConfirm/1"
                                : "/Admission/TestBatch"
                            }`
                          )
                        }
                        to="javascript:void(0)"
                      >
                        Test Batches
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() =>
                          ToggleOpen(
                            `${
                              user_type !== 2
                                ? "/ListViewStudentConfirm/3"
                                : "/Admission/SpecialClasses"
                            }`
                          )
                        }
                        to="javascript:void(0)"
                      >
                        Special Classes
                      </Link>
                    </li>
                    {/* {user_type !== 2 && ( */}
                    {/* <> */}
                    <li>
                      <Link
                        onClick={() =>
                          ToggleOpen(
                            `${
                              user_type !== 2
                                ? "/ListViewStudentConfirm/4"
                                : "/Admission/Modelexam"
                            }`
                          )
                        }
                        to="javascript:void(0)"
                      >
                        Model Exams
                      </Link>
                    </li>
                    <li>
                      <Link
                        onClick={() =>
                          ToggleOpen(
                            `${
                              user_type !== 2
                                ? "/ListViewStudentConfirm/5"
                                : "/Admission/Mockinterview"
                            }`
                          )
                        }
                        to="javascript:void(0)"
                      >
                        Mock Interviews
                      </Link>
                    </li>
                    {/*  <li>
                          <Link
                            onClick={() =>
                              ToggleOpen(
                                `${
                                  user_type !== 2
                                    ? "/ListViewStudentConfirm/2"
                                    : "/Admission/Counselling"
                                }`
                              )
                            }
                            to="javascript:void(0)"
                          >
                            Counsellings
                          </Link>
                        </li> */}
                    {/* </> */}
                    {/* )} */}
                  </ul>
                </li>

                {/* === STUDY MATERIALS === */}
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    onClick={() =>
                      handleNav(
                        user_type == 2 || !user_type
                          ? "/StudyMaterial/Books"
                          : user_type == 1 ||
                            user_type == 3 ||
                            user_type == 4 ||
                            user_type == 5
                          ? "/studyMaterials/Books/list"
                          : "",
                        0
                      )
                    }
                    to="javascript:void(0)"
                  >
                    Study Materials
                  </Link>
                </li>

                {/* === CART === */}
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="javascript:void(0)"
                    onClick={() => {
                      user_type === 2 && ToggleOpen("/AddToCart");
                    }}
                  >
                    Cart
                  </Link>
                </li>

                {/* === WISHLIST === */}
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="javascript:void(0)"
                    onClick={() => {
                      user_type === 2 && ToggleOpen("/Wishlist");
                    }}
                  >
                    Wishlist
                  </Link>
                </li>

                {/* === About Us === */}
                <li
                  className={`nav-link dropdown-toggle ${isOpen ? "open" : ""}`}
                  onClick={toggleDropdowns}
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  About Us
                  <span
                    className="material-icons dropdown_span"
                    style={{ marginLeft: "78%" }}
                    onClick={toggleDropdowns}
                  >
                    expand_more
                  </span>
                  <ul className={`dropdown-menu ${isOpen ? "open" : ""}`}>
                    {/*  All users can see Images & Videos */}
                    <li>
                      <Link
                        onClick={() => ToggleOpen("/WhoWeAre")}
                        to="javascript:void(0)"
                      >
                        Who We Are
                      </Link>
                    </li>

                    <li>
                      <Link
                        onClick={() => ToggleOpen("/WhyChooseUs")}
                        to="javascript:void(0)"
                      >
                        Why Choose Us
                      </Link>
                    </li>
                  </ul>
                </li>

                {/* === GALLERY === */}
                <li
                  className={`nav-link dropdown-toggle ${isOpen ? "open" : ""}`}
                  onClick={toggleDropdowns}
                  data-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  Gallery
                  <span
                    className="material-icons dropdown_span"
                    style={{ marginLeft: "78%" }}
                    onClick={toggleDropdowns}
                  >
                    expand_more
                  </span>
                  <ul className={`dropdown-menu ${isOpen ? "open" : ""}`}>
                    {/*  All users can see Images & Videos */}
                    <li>
                      <Link
                        onClick={() => ToggleOpen("/GalleryImages")}
                        to="javascript:void(0)"
                      >
                        Images
                      </Link>
                    </li>

                    <li>
                      <Link
                        onClick={() => ToggleOpen("/GalleryVideos")}
                        to="javascript:void(0)"
                      >
                        Videos
                      </Link>
                    </li>

                    {/*  Slides shown if Admin or has Gallery access */}
                    {(user_type === 1 || hasGalleryAccess) && (
                      <li>
                        <Link
                          onClick={() => ToggleOpen("/ViewBannerAdmin")}
                          to="javascript:void(0)"
                        >
                          Slides
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>

                {/* === CONTACT US === */}
                <li className="nav-item">
                  <Link
                    className="nav-link"
                    to="javascript:void(0)"
                    onClick={() => ToggleOpen("/ContactUs")}
                  >
                    Contact us
                  </Link>
                </li>

                <li className="nav-item">
                  <>
                    {/* === ADMIN MENU === */}
                    {user_type === 1 &&
                      AdminMenu.map((item, i) => (
                        <Link
                          className="nav-link"
                          key={i}
                          to="javascript:void(0)"
                          onClick={() => ToggleOpen(item.path)}
                        >
                          {item.lable}
                        </Link>
                      ))}

                    {/* === STUDENT MENU === */}
                    {user_type === 2 && (
                      <>
                        {StudentMenu.map((item, i) => {
                          if (item.value === "View Schedule") {
                            return (
                              <li
                                className={`dropdown-toggle mt-3 ${
                                  isOpens ? "open" : ""
                                }`}
                                onClick={toggleDropdowns}
                                data-toggle="dropdown"
                                aria-haspopup="true"
                                aria-expanded="false"
                              >
                                View Schedule
                                <span
                                  class="material-icons dropdown_spansss"
                                  onClick={toggleDropdowns}
                                >
                                  expand_more
                                </span>
                                {tPer.length > 0 ? (
                                  <ul
                                    className={`dropdown-menu mt-3 ${
                                      isOpens ? "open" : ""
                                    }`}
                                  >
                                    {tPer.map((el) => (
                                      <li key={el.batch_id}>
                                        <Link
                                          onClick={() =>
                                            handleSchedule(
                                              el.batch_id,
                                              el.batch_type
                                            )
                                          }
                                          to="javascript:void(0)"
                                        >
                                          {el.batch_name}
                                        </Link>
                                      </li>
                                    ))}
                                  </ul>
                                ) : (
                                  <ul className="dropdown-menu">
                                    <li>
                                      <Link
                                        className="nav-link"
                                        to="javascript:void(0)"
                                      >
                                        No Batch found
                                      </Link>
                                    </li>
                                  </ul>
                                )}
                              </li>
                            );
                          }

                          // Default items (non-dropdown)
                          return (
                            <li className="nav-item" key={i}>
                              <Link
                                className="nav-link"
                                to="javascript:void(0)"
                                onClick={() => ToggleOpen(item.path)}
                              >
                                {item.lable}
                              </Link>
                            </li>
                          );
                        })}
                      </>
                    )}

                    {/* === STAFF MENU === */}
                    {user_type !== 1 &&
                      user_type !== 2 &&
                      Array.isArray(menuList) &&
                      (() => {
                        const accessibleRoutes = employeeRoutes
                          .filter(
                            (r, i, self) =>
                              i === self.findIndex((x) => x.id === r.id)
                          )
                          .filter((route) =>
                            menuList.some(
                              (menuId) => Number(menuId) === Number(route.id)
                            )
                          );

                        const groupedRoutes = accessibleRoutes.reduce(
                          (acc, route) => {
                            if (!acc[route.module]) acc[route.module] = [];
                            acc[route.module].push(route);
                            return acc;
                          },
                          {}
                        );

                        return (
                          <>
                            {/* Always visible */}
                            <Link
                              className="nav-link"
                              to="javascript:void(0)"
                              onClick={() => ToggleOpen("/facultyProfile")}
                            >
                              My Profile
                            </Link>

                            {/* Dynamic Menus */}
                            {Object.entries(groupedRoutes).map(
                              ([moduleName, routes]) => {
                                const filteredRoute = routes?.filter(
                                  (route) => route?.order === "1"
                                );
                                const firstRoute = filteredRoute?.[0];

                                if (moduleName === "Study Materials") {
                                  const uniqueSubpages = Object.values(
                                    routes
                                      .filter((route) => route?.order === "1")
                                      .reduce((acc, route) => {
                                        const key = `${route.module}-${route.subpage}`;
                                        if (!acc[key]) acc[key] = route;
                                        return acc;
                                      }, {})
                                  );

                                  return (
                                    <div
                                      key={moduleName}
                                      className="module-block"
                                    >
                                      <div className="subpage-container">
                                        {uniqueSubpages && (
                                          <div className="subpage-block">
                                            {uniqueSubpages.map((route) => (
                                              <Link
                                                key={route.id}
                                                className="nav-link"
                                                to="javascript:void(0)"
                                                onClick={() =>
                                                  ToggleOpen(
                                                    route.path.startsWith("/")
                                                      ? route.path
                                                      : `/${route.path}`
                                                  )
                                                }
                                              >
                                                {route.subpage}
                                              </Link>
                                            ))}
                                          </div>
                                        )}
                                      </div>
                                    </div>
                                  );
                                }

                                if (moduleName === "Faculty Profile") {
                                  return (
                                    <div key={moduleName}>
                                      <div>
                                        {routes.map((route) => (
                                          <Link
                                            key={route.id}
                                            className="nav-link"
                                            to="javascript:void(0)"
                                            onClick={() =>
                                              ToggleOpen(
                                                route.path.startsWith("/")
                                                  ? route.path
                                                  : `/${route.path}`
                                              )
                                            }
                                          >
                                            {route.page}
                                          </Link>
                                        ))}
                                      </div>
                                    </div>
                                  );
                                }

                                if (!firstRoute) return null;
                                return (
                                  <Link
                                    key={firstRoute.id}
                                    className="nav-link"
                                    to="javascript:void(0)"
                                    onClick={() =>
                                      ToggleOpen(
                                        firstRoute.path.startsWith("/")
                                          ? firstRoute.path
                                          : `/${firstRoute.path}`
                                      )
                                    }
                                  >
                                    {firstRoute.module}
                                  </Link>
                                );
                              }
                            )}
                          </>
                        );
                      })()}
                  </>
                </li>

                {/* === LOGIN / LOGOUT === */}
                {user?.user_id ? (
                  <li className="nav-item" onClick={Logout}>
                    <Link className="nav-link" to="javascript:void(0)">
                      Logout
                    </Link>
                  </li>
                ) : (
                  <li className="nav-item" onClick={Logout}>
                    <Link className="nav-link" to="/login">
                      Login
                    </Link>
                  </li>
                )}
              </ul>
            </div>
          </div>
        </div>
      </nav>

      <Subnav record={location} />
    </>
  );
}
export default HeaderHome;
